import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  AddBlockedByInput,
  createIssueAddBlockedByMutation,
  createIssueAddBlockedByMutation$data,
} from './__generated__/createIssueAddBlockedByMutation.graphql'

export function commitCreateIssueAddBlockedByMutation({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: AddBlockedByInput
  onError?: (error: Error) => void
  onCompleted?: (response: createIssueAddBlockedByMutation$data) => void
}) {
  return commitMutation<createIssueAddBlockedByMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation createIssueAddBlockedByMutation($input: AddBlockedByInput!) @raw_response_type {
        addBlockedBy(input: $input) {
          issue {
            id
          }
          blockingIssue {
            id
          }
          # Note: We don't fetch the updated blocked/blockedBy relationships here
          # because this mutation runs fire-and-forget after issue creation completes.
          # The user is redirected to the new issue page, which will fetch fresh data.
        }
      }
    `,
    variables: {
      input,
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
